<template>
  <v-row class="px-3 align-center">
    <v-col cols="12" :md="`${allowCreate?'6':'9'}`" :class="`${$vuetify.breakpoint.md ? 'pa-0' : 'py-1'}`" v-if="resourceSettings.search">
      <v-text-field
          :label="`${resourceSettings.searchLabel ? i18n[resourceSettings.searchLabel] : i18n.search}`"
          outlined
          hide-details
          dense
          :name="i18n.search"
          @keypress.enter="searchResource()"
          :append-icon="`${appliedFilters.search? 'close':''}`"
          @click:append="()=>{appliedFilters.search=null;searchResource();}"
          v-model="appliedFilters.search"
          :class="`${arabic?'arFont':'enFont'}`"
        ></v-text-field>
    </v-col>
    <v-col cols="12" md="3" :class="`${$vuetify.breakpoint.md ? 'pa-0' : 'py-1'} px-1`" v-if="resourceSettings.search">
      <v-btn color="primary" :disabled="!appliedFilters.search" @click="searchResource()" block :class="`${arabic?'arFont':'enFont'}`">
        {{i18n.search}}
      </v-btn>
    </v-col>
    <v-col cols="12" :md="`${resourceSettings.search? '3':'12'}`" 
      :class="`${$vuetify.breakpoint.md ? 'pa-0' : 'py-1'} px-1`" v-if="allowCreate">
      <v-btn color="primary" @click="create()" block :class="`${arabic?'arFont':'enFont'}`">
        {{i18n.new}}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props:['loading', 'resourceSettings', 'appliedFilters'],
  methods:{
    
    loadResource() {
      this.$emit('loadResource')
    },
    searchResource() {
      this.$emit('searchResource')
    },
    create() {
      this.$emit('createResource')
    }
  },
  computed:{
    allowCreate(){
      if(this.resourceSettings) {
        if( this.resourceSettings.create && !this.resourceSettings.master_create) {
          return true
        } 
        if(this.resourceSettings.master_create && this.master) {
          return true
        }
      }
      return false;
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
     master() {
      return this.$store.state.user.role == 'master';
    },
  }
}
</script>

<style>

</style>